import { selectChangeMessageForMinimumGoals } from '@UI/aside/asideMinimumGoal/asideMinimumGoalSelectors';
import type { EditAsideMinimumGoal } from '@nodeTypeConfig/configTypes';

export const minimumGoalComponent: EditAsideMinimumGoal = {
  component: 'minimumGoals',
  reactComponent: 'AsideMinimumGoal',
  definiteArticle: true,
  label: 'Minimumdoel',
  asideChangeMessageSelector: selectChangeMessageForMinimumGoals,
  options: {
    clearable: true,
    relationTypes: ['IMPLEMENTS'],
  },
};
